import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import DocumentsByTable from "../../organisms/empresas/DocumentsByTable";
import {
    GET_ANNUAL_STATEMENT_DOCUMENTS,
    GET_COMPILANCE_OPINIONS_DOCUMENTS,
    GET_ENTERPRISE_BY_ID,
    GET_FINANCIAL_REPORTING,
    GET_LEGAL_ENTITIE_DOCUMENTS,
    GET_MAILBOX,
    GET_NATURAL_PERSON_DOCUMENTS,
    GET_PROVISIONAL_PAYMENTS_DOCUMENTS
} from "../../../api/apiEmpresas";
import MenuDocHeader from "../../organisms/clientes/empresas/headers/MenuDocHeader";
import { useSession } from "../../../context/SessionContext";

const documentFetchers = {
    archivo_permanente: {
        NaturalPerson: GET_NATURAL_PERSON_DOCUMENTS,
        LegalEntitie: GET_LEGAL_ENTITIE_DOCUMENTS,
    },
    opiniones_cumplimiento: GET_COMPILANCE_OPINIONS_DOCUMENTS,
    pagos_provicionales: GET_PROVISIONAL_PAYMENTS_DOCUMENTS,
    declaracion_anual: GET_ANNUAL_STATEMENT_DOCUMENTS,
    reportes_financieros: GET_FINANCIAL_REPORTING,
    buzones: GET_MAILBOX,
};

const MenuDocTemplate = () => {
    const { id, tabla } = useParams();
    const [empresa, setEmpresa] = useState();
    const [loading, setLoading] = useState(false);
    const [documentos, setDocumentos] = useState();
    const { user } = useSession();

    const fetchDocuments = useCallback(async (empresa) => {
        try {
            const fetcher = tabla === "archivo_permanente"
                ? documentFetchers[tabla]?.[empresa.type]
                : documentFetchers[tabla];

            if (fetcher) {
                const data = await fetcher(empresa.id);
                setDocumentos(data);
            }
        } catch (error) {
            console.error("Error al obtener documentos:", error);
        }
    }, [tabla]);

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const empresaData = await GET_ENTERPRISE_BY_ID(id);
                await fetchDocuments(empresaData);
                setEmpresa(empresaData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [id, tabla, fetchDocuments]);
    return (
        <div className="space-y-2">
            <MenuDocHeader
                empresa={empresa} tabla={tabla}
            />
            {user?.role === "Client" && user?.roleInfo?.isAllowed === false ?
                <div className="text-center">
                    <p>Contacta con tu asesor</p>
                </div>
                :
                (empresa && !loading ?
                    <DocumentsByTable empresa={empresa} docs={documentos} tabla={tabla} user={user} loading={loading} setLoading={setLoading} />
                    :
                    <div className="w-full h-full flex justify-center items-center">
                        <PropagateLoader color="red" />
                    </div>
                )
            }
        </div>
    );
};

export default MenuDocTemplate;
